import { onBeforeUnmount } from 'vue'

export function useDebounce(fn, wait = 250) {
  let timer = null
  const debounced = (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), wait)
  }
  debounced.cancel = () => clearTimeout(timer)
  onBeforeUnmount(() => clearTimeout(timer))
  return debounced
}
